import React from "react";
import { Link } from "react-router-dom";
import Navigation from "./Navbar";
import Footer from "./Footer";
import events1 from "../image/events1.jpeg";
import logo1 from "../image/logo2.png";
import wasme from "../image/wasme.jpeg"

const Events = () => {

  /* ===================== PAST EVENTS ===================== */
  const pastEvents = [
    {
      id: 1,
      title: "India Inc’s First-ever VUCA Conference",
      date: "28th June, 2025",
      description:
        "A landmark conference addressing Volatility, Uncertainty, Complexity, and Ambiguity (VUCA) in the Indian healthcare and corporate ecosystem.",
      image: events1,
      tags: ["VUCA", "Healthcare", "Leadership", "Policy"]
    },
    {
      id: 2,
      title: "Launch of Global Diaspora of Public Health Dialogues (GdPhD)",
      date: "Recent",
      description:
        "Inauguration of a global platform fostering structured dialogue among public health professionals, policymakers, and global leaders.",
      image: logo1,
      tags: ["Public Health", "Global South", "Dialogue"]
    }
  ];

  /* ===================== UPCOMING EVENTS ===================== */
  const upcomingEvents = [
    {
      id: 1,
      title: "Global South Healthcare Leadership Summit, Africa (2026)",
      date: "2026",
      theme:
        "Bridging Barriers, Building Health: The Africa–India Partnership for Compassionate, Self-sufficient and Equitable Healthcare",
      description:
        "A flagship summit bringing together leaders from Africa and India to shape the future of equitable healthcare systems.",
      tags: ["Africa–India", "Healthcare Leadership", "Global South"]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* ===================== NAVBAR ===================== */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Navigation />
      </div>

      {/* ===================== MAIN CONTENT ===================== */}
      <div className="lg:pt-[200px] pt-[170px] pb-20 px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">

        {/* Page Header */}
        <div className="text-center mb-20">
          <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Events & Dialogues
          </h1>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Curated conferences, leadership summits, and knowledge platforms shaping healthcare,
            policy, and global public health discourse.
          </p>
        </div>

        {/* ===================== PAST EVENTS ===================== */}
        <section className="mb-24">
          <div className="flex items-center mb-10">
            <div className="h-1 w-20 bg-blue-900 rounded-full"></div>
            <h2 className="ml-4 text-4xl font-bold text-blue-900">
              Past Events
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {pastEvents.map(event => (
              <div
                key={event.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group"
              >
                <div className="relative h-auto overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4 bg-white/90 px-3 py-1 rounded-full text-sm font-semibold text-blue-900">
                    {event.date}
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-blue-900 mb-3 group-hover:text-orange-600 transition">
                    {event.title}
                  </h3>
                  <p className="text-gray-600 mb-5">{event.description}</p>

                  <div className="flex flex-wrap gap-2">
                    {event.tags.map((tag, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 bg-blue-50 text-blue-900 text-xs rounded-full border"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ===================== UPCOMING EVENTS ===================== */}
        <section className="mb-24">
  <div className="flex items-center mb-10">
    <div className="h-1 w-20 bg-orange-600 rounded-full"></div>
    <h2 className="ml-4 text-4xl font-bold text-blue-900">
      Upcoming Flagship Event
    </h2>
  </div>

  {upcomingEvents.map(event => (
    <div
      key={event.id}
      className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl shadow-xl border border-orange-200 overflow-hidden"
    >
      <div className="md:flex">
        {/* Image Section */}
        <div className="md:w-2/5">
          <div className="relative h-full min-h-[300px] md:min-h-full">
            <img 
              src={wasme} 
              alt={event.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute top-4 left-4">
              <span className="inline-block px-4 py-2 bg-orange-600 text-white rounded-full text-sm font-semibold shadow-lg">
                Coming in {event.date}
              </span>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="md:w-3/5 p-8">
          <h3 className="text-3xl font-bold text-blue-900 mb-4">
            {event.title}
          </h3>

          <div className="bg-white/80 p-5 rounded-xl border-l-4 border-orange-600 mb-6">
            <p className="italic text-blue-900 text-lg">
              "{event.theme}"
            </p>
          </div>

          <p className="text-gray-700 mb-6">{event.description}</p>

          <div className="flex flex-wrap gap-2 mb-8">
            {event.tags.map((tag, i) => (
              <span
                key={i}
                className="px-3 py-1.5 bg-white text-blue-900 rounded-full border text-sm shadow-sm"
              >
                {tag}
              </span>
            ))}
          </div>

          <Link
            to="/contact"
            className="inline-block px-6 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition shadow-md hover:shadow-lg"
          >
            Register Interest
          </Link>
        </div>
      </div>
    </div>
  ))}
</section>

        {/* ===================== FEATURED INSIGHT ===================== 
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
            Featured Insight from VUCA Deliberations
          </h2>

          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-blue-900 mb-3">
              Global Public Health Emergencies: Insights for Future Preparedness
            </h3>

            <p className="text-gray-700 mb-4">
              Based on India’s response to the COVID-19 pandemic
            </p>

            <p className="text-gray-600 mb-6">
              <strong>Author:</strong> Dr. Urvashi Prasad <br />
              Public Health & Policy Specialist; Former Director, Office of Vice Chairperson,
              NITI Aayog, Government of India
            </p>

            <a
              href="https://9vom.in/journals/index.php/gshj/article/view/475"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-600 font-semibold hover:underline"
            >
              Click here to read full article →
            </a>
          </div>
        </section> */}
      </div>

      {/* ===================== FOOTER ===================== */}
      <Footer />
    </div>
  );
};

export default Events;
